import {Injectable} from '@angular/core';
import {io} from 'socket.io-client';
import {chat_service_location} from './../../environments/environment';
import {NGXLogger} from "ngx-logger";
import async from 'async';
import {TimeService} from "./time/time.service";
import {ChatMsg} from "../modele/chatModel";
import {User} from "../modele/user/userModel";
import {UserService} from "./user.service";
import {BackendService} from "./api/backend.service";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ChatService {

    private log_prefix:string = this.constructor.name+":";
    private socket;
    private socket_uid:string;
    private userRequestedToJoinRooms:string[] = [];
    private userRequestedToLeaveRooms:string[] = [];
    private userIsInRooms: string[] = [];
    private messageListAsSubject: Subject<Array<ChatMsg>> = new Subject();
    private currentUser: User = new User();

    messageBuffer: Array<ChatMsg> = [];

    constructor(
        private logger: NGXLogger,
        private timeSrv: TimeService,
        private userService: UserService,
        private bes: BackendService,
    ) {
        this.userService.getUserSubject().subscribe(user => {
            this.currentUser = user;
        });
        this.logger.info(this.log_prefix,"socket setup called -> chat_service_location",chat_service_location);
        this.setupSocketConnection();
    }

    setupSocketConnection(){
        // this.logger.info(this.log_prefix,"socket setup called -> chat_service_location",chat_service_location);
        this.socket = io(chat_service_location);
        this.logger.info(this.log_prefix,"socket setup called -> socket",this.socket);

    }

    // getSocket():any{
    //     return this.socket;
    // }

    getMessageListAsSubject():Subject<Array<ChatMsg>>{
        return this.messageListAsSubject;
    }

    sendChatMessage(messageToSend:string):void{

        this.socket.emit('data.chat.message', messageToSend);
    }

    joinChatRoom(roomIdToJoin: string):void{
        let uid = this.socket.id;
        this.socket_uid = uid;
        this.logger.info(this.log_prefix,"user[",uid,"] requested to join room[",roomIdToJoin,"]");
        if(this.userIsInRooms.indexOf(roomIdToJoin) === -1){
            this.logger.info(this.log_prefix,"user[",uid,"] is not in room [",roomIdToJoin,"] requesting to join");
            if(roomIdToJoin != null){
                this.socket.emit('signal.join.chat.room', roomIdToJoin);
            }

            this.userRequestedToJoinRooms.push(roomIdToJoin);
            this.updateRoomSubscription();
        } else {
            this.logger.info(this.log_prefix,"user[",uid,"] already is in room[",roomIdToJoin,"]");
        }
    }

    leaveChatRoom(roomIdToLeave: string){
        let uid = this.socket.id;
        this.logger.info(this.log_prefix,"user[",uid,"] requested to leave room[",roomIdToLeave,"]");
        if(this.userIsInRooms.indexOf(roomIdToLeave) >= 0){
            this.logger.info(this.log_prefix,"user[",uid,"] was in room -> requesting to leave");
            if(roomIdToLeave != null){
                this.socket.emit('signal.leave.chat.room', roomIdToLeave);
            }
            this.userRequestedToLeaveRooms.push(roomIdToLeave);
            this.updateRoomSubscription();
        } else {
            this.logger.info(this.log_prefix,"user[",uid,"] is not in room");
        }
    }

    updateRoomSubscription(){
        this.logger.info(this.log_prefix,"updateRoomSubscription called ->",this.userRequestedToJoinRooms);
        if(this.userRequestedToJoinRooms.length > 0){
            async.forEachOf(this.userRequestedToJoinRooms, (roomId, index, callback)=>{
                this.logger.info(this.log_prefix,"handling join request index[",index,"] roomId[",roomId,"]");
                if(this.userIsInRooms.indexOf(roomId) >= 0){
                    this.logger.info(this.log_prefix,"user already in room:[",roomId,"]");
                } else {
                    this.logger.info(this.log_prefix,"setting up listener for room[",roomId,"]");
                    this.socket.on(roomId, (message: string, messageMeta?: Object) => {
                        this.logger.info(this.log_prefix,roomId,"received message:",message,":opt_data:",Object.keys(messageMeta));

                        let timeDiff = this.timeSrv.convertDate(new Date());
                        let newMsg = new ChatMsg (
                            message,
                            this.currentUser.user_name,
                            this.currentUser.user_avatar,
                            timeDiff,
                            roomId
                        );

                        if(this.currentUser.user_id == -1){
                            newMsg.user_avatar = this.bes.getBackendDummyImage();
                            newMsg.user_name = this.socket_uid;
                        }
                        if(messageMeta.hasOwnProperty('sender_id') === true){
                            newMsg.sent_by = messageMeta['sender_id'];
                        }

                        this.messageBuffer.push(newMsg);
                        this.messageListAsSubject.next(this.messageBuffer);
                        // this.logger.info(this.log_prefix,"created msg:",newMsg);
                    });
                    this.userIsInRooms.push(roomId);
                    this.userRequestedToJoinRooms.splice(this.userRequestedToJoinRooms.indexOf(roomId),1);
                }

                callback();
            }, (err)=>{
                if(err){
                    this.logger.info(this.log_prefix,"have error listening to [",this.userRequestedToJoinRooms.length,"] rooms");
                }
                this.logger.info(this.log_prefix,"completed join room request");
            });
        } else {
            this.logger.info(this.log_prefix,"no join room requests to handle");
        }

        if(this.userRequestedToLeaveRooms.length > 0){
            async.forEachOf(this.userRequestedToLeaveRooms, (roomId, index, callback)=>{
                this.logger.info(this.log_prefix,"handling index[",index,"] -> leave room request for room [",roomId,"]");
                if(this.userIsInRooms.indexOf(roomId) >= 0){
                    this.logger.info(this.log_prefix,"user is in room:[",roomId,"]");

                    this.logger.info(this.log_prefix,"user wants to leave room[",roomId,"] / have [",this.messageBuffer.length,"] messages in buffer:",this.messageBuffer);
                    this.socket.off(roomId);
                    this.logger.info(this.log_prefix,"disconnected from room [",roomId,"]");
                    this.userIsInRooms.splice(this.userIsInRooms.indexOf(roomId), 1);
                    this.userRequestedToJoinRooms.splice(this.userRequestedToJoinRooms.indexOf(roomId), 1);
                    this.userRequestedToLeaveRooms.splice(this.userRequestedToLeaveRooms.indexOf(roomId), 1);
                    if(this.userIsInRooms.length === 0){
                        this.messageBuffer = [];

                    } else {
                        this.messageBuffer.map((message, index, array) => {
                            let {room_id} = message;
                            let needsDeletion = room_id == roomId;
                            this.logger.info(this.log_prefix,"disconnect check msg:rid[",room_id,"]/del[",needsDeletion,"]",message);
                            if(needsDeletion === true){
                                array.splice(index, 1);
                            }
                        });
                    }
                    this.messageListAsSubject.next(this.messageBuffer);

                } else {
                    this.logger.info(this.log_prefix,"user currently is not in room [",roomId,"]");
                }

                callback();
            }, (err)=>{
                if(err){
                    this.logger.info(this.log_prefix,"have error disconnecting to [",this.userRequestedToJoinRooms.length,"] room/s");
                }
                this.logger.info(this.log_prefix,"completed leave room request");
            })
        } else {
            this.logger.info(this.log_prefix,"no leave room requests to handle");
        }

    }

}
